import { useEffect } from "react";
import { useRefCache } from "../useRefCache";
import { delegateEvent } from "./delegateEvent";
import { isSupported } from "./passiveEvents";
/**
 * This hook will create a performant scroll listener by enabling passive events
 * if it's supported by the browser and delegating the event as needed.
 */
export function useScrollListener(_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? true : _b, onScroll = _a.onScroll, element = _a.element, _c = _a.options, options = _c === void 0 ? isSupported ? { passive: true } : false : _c;
    var callback = useRefCache(onScroll);
    useEffect(function () {
        if (!enabled) {
            return;
        }
        var eventHandler = delegateEvent("scroll", element || window, true, options);
        var handler = function (event) { return callback.current(event); };
        eventHandler.add(handler);
        return function () {
            eventHandler.remove(handler);
        };
        // disabled since useRefCache
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, element, options]);
}
//# sourceMappingURL=useScrollListener.js.map